import SC from "./style";
import { useEffect, useState } from "react";
import { Button, Label } from "InnoUI/components";
import theme from "theme";
import BulkActionView from "InnoUI/components/BulkActionView";
import { InputField } from "components";
import { apiPost } from "api/callApi";
import { regexTypes } from "utils/config";
import { showAlert } from "utils/helper";
import { Switch } from "@mui/material";

const SmartFolderColumn = (props) => {
  const {
    setOpenModalView,
    openModalView,
    reloadData,
    rowData,
    isEditing,
    setRowData,
  } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    systemColumn: 0,
  });

  useEffect(() => {
    if (isEditing && rowData) {
      setData({ ...rowData, columnName: rowData.label });
    }
  }, [isEditing, rowData]);

  const handleChange = (property, value) => {
    // Check if the value starts with a number
    if (/^\d/.test(value)) {
      // Prevent updating the state if the value starts with a number
      return;
    }

    setData((prevData) => ({
      ...prevData,
      [property]: value,
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const endpoint = isEditing
        ? `/v1/reportcolumn/${rowData.id}`
        : `/v1/reportcolumn`;
      const response = await apiPost(endpoint, data);
      showAlert({ title: "Success", text: response.message, icon: "success" });
      setOpenModalView(false);
      setData({});
      console.log(response, "response");

      await reloadData(response?.data?.reportColumnId);
      setRowData(null);
    } catch (error) {
      showAlert({
        title: "Error",
        text: error.response.data.message,
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCancelModal = () => {
    setOpenModalView(false);
    setData({});
    setRowData(null);
  };

  const AddModalData = () => {
    return (
      <div>
        <div style={{ marginTop: "30px" }}>
          <Label label={"Column Name"}>
            <div style={{ display: "flex", padding: "0px" }}>
              <InputField
                name="columnName"
                value={data?.columnName}
                onChange={handleChange}
                style={{ width: "90%" }}
                // capitalize
                regexType={regexTypes.textWithNumber}
              />
            </div>
          </Label>

          <Label label={"System Column"}>
            <div style={{ display: "flex", padding: "0px" }}>
              <Switch
                checked={data?.systemColumn}
                name="systemColumn"
                onChange={(e) => handleChange("systemColumn", e.target.checked)}
                inputProps={{ "aria-label": "controlled" }}
                disabled={rowData?.systemColumn == 1}
              />
            </div>
          </Label>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            margin: "20px",
          }}
        >
          <Button
            caption="Cancel"
            onClick={handleCancelModal}
            fontSize="12px"
            style={{
              marginBottom: 8,
              background: theme.colors.cancelButton,
              color: theme.colors.white,
              minWidth: "90px",
              borderRadius: "3px",
              height: "30px",
              fontSize: "12px",
            }}
          />

          <Button
            caption={"Save"}
            isLoading={loading}
            onClick={handleSubmit}
            color="white"
            fontSize="12px"
            style={{
              marginBottom: 8,
              background: theme.gradient.themeGradient,
              color: theme.colors.white,
              minWidth: "90px",
              height: "30px",
              borderRadius: "3px",
            }}
          />
        </div>
      </div>
    );
  };

  return (
    <>
      {openModalView && (
        <BulkActionView
          title={isEditing ? "Edit Column" : "New Column"}
          openModal={openModalView}
          renderBodyConditionally={AddModalData}
          handleCloseModal={() => {
            setOpenModalView(false);
            setData("");
            setRowData(null);
          }}
        />
      )}
    </>
  );
};

export default SmartFolderColumn;
